import getConfig from "next/config";

import StoreSchedule from "@components/ProductPage/ProductStoreAvailability/StoreSchedule";
import StoreSpecialSchedule from "@components/ProductPage/ProductStoreAvailability/StoreSpecialSchedule";
import Button from "@components/Button";

const {
  publicRuntimeConfig: { settings },
} = getConfig();

const StoreSelectModalStoreCard = ({
  storeData,
  onStoreSelect,
  selectedStoreId,
}) => {
  const hasSpecialSchedule = Boolean(storeData.special_schedule);
  const isSelectedStore = selectedStoreId === storeData.id;

  return (
    <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-[20px]">
      <div className="text-[14px]">
        {storeData?.name && (
          <div className="capitalize font-medium ">{storeData.name}</div>
        )}
        {storeData.address && storeData.address}

        {hasSpecialSchedule ? (
          <StoreSpecialSchedule schedule={storeData.special_schedule} />
        ) : (
          <StoreSchedule schedule={storeData.schedule} />
        )}

        <a
          href={`${settings.baseUrl}/magazine/${storeData.url_key}/`}
          rel="noopener noreferrer"
          target="_blank"
          className="text-red-brand hover:text-bleu-hover underline"
          title=""
        >
          Vezi harta
        </a>
      </div>

      <div className="flex flex-col md:flex-row gap-[10px] md:gap-[20px] min-w-fit">
        {isSelectedStore ? (
          <Button
            title="Selectat"
            variant="third"
            size="small"
            classesProp="pointer-events-none"
          />
        ) : (
          <Button
            title="Selecteaza magazinul"
            onClick={() => onStoreSelect(storeData)}
            size="small"
            classesProp="min-w-fit"
          />
        )}
      </div>
    </div>
  );
};

export default StoreSelectModalStoreCard;
